// eslint-disable-next-line no-unused-vars
import React from 'react'
import { connect } from 'react-redux'
import actions from './actions'
import SelectAreaCode from './SelectAreaCode'

const mapStateToProps = ({ areaCodes }) => {
  return { areaCodes: areaCodes }
}

const mapDispatchToProps = dispatch => ({
  getAreaCodes: operatorKey => dispatch(actions.getAreaCodes(operatorKey)),
  clearAreaCodes: () => dispatch(actions.clearAreaCodes())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectAreaCode)



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/PhoneNumber/SelectAreaCode/SelectAreaCodeContainer.js